export default {
  signIn: 'Iniciar sesión',
  signOut: 'Cerrar sesión',
  points: 'puntos',
  hyattSignInButton: 'Iniciar sesión en World of Hyatt',
};
